var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8875 13.5062C7.675 13.5812 7.325 13.5812 7.1125 13.5062C5.3 12.8875 1.25 10.3062 1.25 5.93125C1.25 4 2.80625 2.4375 4.725 2.4375C5.8625 2.4375 6.86875 2.9875 7.5 3.8375C8.13125 2.9875 9.14375 2.4375 10.275 2.4375C12.1938 2.4375 13.75 4 13.75 5.93125C13.75 10.3062 9.7 12.8875 7.8875 13.5062Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactions);
export default __webpack_public_path__ + "static/media/reactions.9fbb60e5b11ca7b54f278e8235b93418.svg";
export { ForwardRef as ReactComponent };